import { FC } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IExportRecipientsParams } from '@app/models/interfaces';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { useExportRecipientsQuery } from '../../../../hooks';

interface IProps {
  params: IExportRecipientsParams;
}

export const ExportButton: FC<IProps> = ({ params }) => {
  const { token } = theme.useToken();
  const recipientsT = useTranslation(NSKeys.recipients);
  const currentSession = useLocalSelector((state) => state.currentSession);

  const { mutate, status } = useExportRecipientsQuery();

  if (!currentSession.dictionariesContext?.scope?.$permissions?.export_recipients) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={recipientsT.t('exportTooltip')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate(params)}
      />
    </Tooltip>
  );
};
